var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicComponent,_vm._b({tag:"component",attrs:{"value":_vm.internalValue,"params":_vm.params,"return-object":false},on:{"input":_vm.handleInput}},'component',_vm.filterProps(_vm.input.props, ['isFormElement', 'selectParents']),false))
}
var staticRenderFns = []

export { render, staticRenderFns }